import { API_BASE_URL } from "../../../constants";

export function getTotalCareDashboard(token: String) {
  return fetch(`${API_BASE_URL}/total_care_dashboard?token=${token}`);
}

export function showTotalCareDashboard(token: String) {
  return fetch(`${API_BASE_URL}/display_total_care_tab?token=${token}`);
}
